import * as angular from 'angular';
import * as _ from 'lodash';
import template from './roleLocation.tpl.html';
import {States} from "../../shared/config/constant.module";
import {NavigationModel, Plant} from "../../models/navigation";
import {apsCommon} from "../../shared/dto/aps.common";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import AuthServiceName, {AuthService} from "../../services/auth/auth.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import {StateParams} from "../../common";
import {apsEnums} from "../../shared/dto/aps.enums";

let requires = [AuthDataServiceName, AuthServiceName, NavigationServiceName];

interface RoleLocationParams extends StateParams {
  shift: apsEnums.Shift;
}

interface RoleLocationController {
  plants(): Plant[];
  roles: apsCommon.UserRolePlants[];
  selectedRole: apsCommon.UserRolePlants;
  navigation: NavigationModel;
  form: angular.IFormController;
  roleChanged(): void;
  continue(): void;
}

export default angular.module('aps.controller.roleLocation', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.SELECT_ROLE,
      url: '/selectRole?userId&shift',
      controller: 'RoleLocationCtrl as vm',
      template: template,
      data: {pageTitle: 'Select Role and PlantLocation'}
    });
  })
  .controller('RoleLocationCtrl', roleLocationCtrl)
  .name;

function roleLocationCtrl(
  authDataService: AuthDataService,
  authService: AuthService,
  navigationService: NavigationService,
  $state: angular.ui.IStateService,
  $stateParams: RoleLocationParams
) {
  var vm = this as RoleLocationController;
  // Temporary - do not include the Plant Performance Dashboard role in the list here as this role is behind the scenes only
  vm.roles = authDataService.getRoles().filter(x => x.roleName != 'Plant Performance Dashboard');
  var currentRole = authDataService.getSelectedRoleLocation();
  if (currentRole && currentRole.role) {
    vm.selectedRole = _.find(vm.roles, {roleId: currentRole.role.roleId});
  } else {
    vm.selectedRole = _.find(vm.roles, {lastSelected: true});
  }
  if (!vm.selectedRole) {
    vm.selectedRole = vm.roles[0];
  }

  vm.roleChanged = () => {
    navigationService.setCurrentRole(vm.selectedRole);
  };
  vm.roleChanged();

  var ignoreErrors = false;

  vm.plants = () => {
    if (!vm.navigation) {
      return [];
    }

    if (vm.selectedRole && vm.selectedRole.roleRequiresPlants && vm.selectedRole.plants) {
      return _.filter(vm.navigation.plants(), p => _.some(vm.selectedRole.plants, rp => rp.id === p.id));
    }
    return vm.navigation.plants();
  };

  navigationService.getNavigation().then((navigation) => {
    vm.navigation = navigation;

    if (vm.roles.length === 1 &&
      (!vm.selectedRole.roleRequiresPlants || (
        vm.selectedRole.plants.length === 1 &&
        !vm.selectedRole.roleRequiresShops
      ))) {
      ignoreErrors = true;
      vm.continue();
      return;
    }

    if (currentRole && currentRole.plant) {
      vm.navigation.selectedPlant = _.find(vm.plants(), {id: currentRole.plant.id});
      vm.navigation.plantChanged();
      if (currentRole.shop) {
        vm.navigation.selectedShop = _.find(vm.navigation.shops(), {id: currentRole.shop.id});
      }
    }
  });

  vm.continue = () => {
    if (!ignoreErrors && vm.form.$invalid) {
      return;
    }

    authService.setRoleLocation(
      vm.selectedRole,
      vm.navigation.selectedPlant,
      vm.navigation.selectedShop,
      $stateParams.shift
    ).then(() => {

        navigationService.clearSetRole();

        var params: StateParams = {
          plantId: vm.navigation.selectedPlant.id,
          shopId: vm.navigation.selectedShop.id,
          userId: $stateParams.userId
        };

        authService.getUserData().then(() => {
          if (!vm.selectedRole.roleRequiresPlants) {
            $state.go(States.ADMIN_DASHBOARD, params);
            return;
          } else if (!vm.selectedRole.roleRequiresShops) {
            $state.go(States.PLANT_DASHBOARD, params);
            return;
          }
          $state.go(States.DASHBOARD, params);
        });
    });
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/roleLocation/roleLocation.controller.ts